import { render, staticRenderFns } from "./SegmentInfo.vue?vue&type=template&id=0e759abc&"
import script from "./SegmentInfo.vue?vue&type=script&lang=js&"
export * from "./SegmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./SegmentInfo.vue?vue&type=style&index=0&id=0e759abc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports